<template>
  <div>
    <!-- -------- Filters -------- -->
    <div class="row"><div class="col-12"><hr class="my-3" /></div></div>

    <div class="row d-none d-md-flex">
      <div class="col-3"><small class="text-muted">Search by text</small></div>
      <div class="col-3"><small class="text-muted">Search by date range</small></div>
      <div class="col-3"></div><div class="col-3"></div>
    </div>

    <div class="row d-block d-md-none">
      <div class="col-12"><small class="text-muted">Filter routes</small></div>
    </div>

    <div class="row">
      <div class="col-12 col-md-3 my-2">
        <input class="form-control" type="text" v-model="searchString" placeholder="Name or description" />
      </div>
      <div class="col-12 col-md-3 my-2">
        <input class="form-control" type="date" v-model="startDate" placeholder="Start Date" />
      </div>
      <div class="col-12 col-md-3 my-2">
        <input class="form-control" type="date" v-model="endDate" placeholder="End Date" />
      </div>
      <div class="col-12 col-md-3 my-2">
        <button class="btn btn-primary btn-sm" @click="searchPlannedTrailsClicked($event, true)">Search</button>
        <button class="btn btn-text btn-sm" @click="clearSearchFilters($event)">Clear</button>
      </div>
    </div>

    <div class="row"><div class="col-12"><hr class="my-3" /></div></div>

    <!-- -------- List -------- -->
    <div class="bg-dark p-3 rounded-lg">
      <div v-if="plannedTrails.length">
        <div v-for="(trail,index) in plannedTrails" :key="trail.id || index">
          <div class="row">
            <a :href="trail.shareableUrl" class="col-12 col-md-2 d-flex align-items-center justify-content-center square p-1">
              <img :src="trail.thumbnailUrl" class="rounded img-fluid my-2" width="176" height="98" alt="Planned Trail Thumbnail" />
            </a>

            <div class="col-12 col-md-10 my-2 d-flex align-items-center justify-content-between">
              <div>
                <a :href="trail.shareableUrl"><h3 class="display-5"><b>{{ trail.title || 'Untitled Planned Trail' }}</b></h3></a>
                <p class="text-muted"><small>{{ formatDate(trail.createdAt) }}</small></p>
              </div>

              <!-- -------- Dropdown -------- -->
              <div class="dropdown float-end align-self-start">
                <button class="btn btn-secondary dropdown-toggle d-flex align-items-center"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="material-icons">more_vert</span>
                </button>
                <ul class="dropdown-menu">
                  <li v-if="formMode"><button class="dropdown-item" @click="selectPlannedTrail($event, trail)">Select Route</button></li>
                  <li><a class="dropdown-item" :href="trail.shareableUrl">View Map</a></li>
                  <li><button class="dropdown-item" @click="exportGpx(trail)">Export GPX</button></li>
                  <li><button class="dropdown-item" @click="showFlyover($event, trail)">3D Preview</button></li>
                  <li><a class="dropdown-item" :href="printPlannedTrail(trail)">Print Map</a></li>
                  <li><button class="dropdown-item" @click="editPlannedTrail($event, trail)">Edit Route</button></li>
                  <li><button class="dropdown-item" @click="triggerCopyModel($event, trail)">Share Route</button></li>
                  <li><button class="dropdown-item" @click="deletePlannedTrail($event, trail)">Delete Route</button></li>
                </ul>
              </div>
              <!-- /Dropdown -->
            </div>
          </div>

          <div class="row"><div class="col-12"><hr class="my-3" /></div></div>
        </div>
      </div>
      <div v-else><p>No hikes found.</p></div>

      <div v-if="hasMoreTrails" class="see-more d-flex justify-content-center m-0">
        <button class="btn btn-link" @click="searchPlannedTrailsClicked($event, false)">See More</button>
      </div>

      <LoadingDialog :show-loading-dialog="loading" />

      <!-- -------- Share Modal -------- -->
      <div id="copyModal" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-between">
              <h3 id="linkModalLabel" class="modal-title m-0"><strong>Share</strong></h3>
              <button id="close" class="close btn-link" data-bs-dismiss="modal" aria-label="Close"><span>×</span></button>
            </div>
            <div class="modal-body">
              <p class="mb-1"><strong>Trail Link</strong> <span id="copyURLConfirmation" class="text-yellow" style="display:none">(Copied!)</span></p>
              <p class="mb-3"><small class="text-muted">Anyone with this link can view your trail</small></p>

              <div class="input-group mb-3" id="copyURLInputGroup" @click="copyToClipboard">
                <input id="trailShareInput" class="form-control" type="text" />
                <button class="btn btn-primary input-group-text" type="button">
                  <span class="material-icons">content_copy</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Share Modal -->
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import graph_client from '../../utils/graphql/graph_client'
import {
  DestroyPtv2PlannedTrail,
  GetPtv2PlannedTrail } from '../../utils/graphql/planned-trail-graph'
import { SearchPtv2PlannedTrailsQuery } from '../../utils/graphql/planned-trails'
import LoadingDialog from '../../utils/shared_components/LoadingDialog.vue'
import moment from 'moment/moment'
import { Modal, Dropdown } from 'bootstrap'

import { getFeatureCollectionLineString } from '../../utils/getFeatureCollectionLineString'
import { geojsonToGpx } from '../../utils/geojsonToGpx'

export default {
  name: 'PlannedTrails',
  components: { LoadingDialog },
  props: {
    formMode: { type: Boolean, default: false }
  },
  data () {
    return {
      plannedTrails: [],
      searchString: '',
      startDate: null,
      endDate: null,
      currentPage: 1,
      pageSize: 10,
      hasMoreTrails: false,
      loading: true,
      dropdownInstances: []
    }
  },
  mounted () {
    this.searchPlannedTrails(true)
  },
  beforeUnmount () {
    this.dropdownInstances.forEach(d => d.dispose())
    this.dropdownInstances = []
  },
  methods: {
    /* ---------- Utilities ---------- */
    formatDate (date) { return moment(date).format('LLL') },
    initializeDropdowns () {
      this.dropdownInstances.forEach(d => d.dispose())
      this.dropdownInstances = []
      const list = this.$el.querySelectorAll('[data-bs-toggle="dropdown"]')
      list.forEach(el => this.dropdownInstances.push(Dropdown.getOrCreateInstance(el)))
    },

    /* ---------- Searching ---------- */
    searchPlannedTrailsClicked (e, reset = false) { e.preventDefault(); this.searchPlannedTrails(reset) },
    searchPlannedTrails (reset = false) {
      this.loading = true
      if (reset) { this.currentPage = 1; this.plannedTrails = [] }

      const variables = {
        search: this.searchString,
        startDate: this.startDate || null,
        endDate: this.endDate || null,
        page: this.currentPage,
        pageSize: this.pageSize
      }

      graph_client.request(SearchPtv2PlannedTrailsQuery, variables)
        .then(({ ptv2PlannedTrailsTextSearch: newTrails }) => {
          this.plannedTrails = reset ? newTrails : this.plannedTrails.concat(newTrails)
          this.hasMoreTrails = newTrails.length === this.pageSize
          if (this.hasMoreTrails) this.currentPage += 1
          this.$nextTick(() => this.initializeDropdowns())
        })
        .catch(err => console.error('Error fetching planned trails:', err))
        .finally(() => { this.loading = false })
    },
    clearSearchFilters (e) {
      e.preventDefault()
      this.searchString = ''; this.startDate = null; this.endDate = null
      this.searchPlannedTrails(true)
    },

    /* ---------- Actions ---------- */
    selectPlannedTrail (e, trail) {
      e.preventDefault()
      window.trailSelected(trail.id)
      window.trailSelectedName(trail.title)
      window.closeVueModal()
    },
    editPlannedTrail (e, trail) { e.preventDefault(); window.location = `${trail.shareableUrl}/edit` },
    printPlannedTrail (trail) { return `/print-maps?data_ids[]=${trail.id}&data_types[]=Ptv2::PlannedTrail` },
    showFlyover (e, trail) {
      e.preventDefault()
      window.showMapModalForPlannedTrail
        ? window.showMapModalForPlannedTrail(trail.id)
        : console.error('showMapModalForPlannedTrail not found')
    },
    deletePlannedTrail (e, trail) {
      e.preventDefault()
      if (!confirm('Are you sure you want to delete this planned trail?')) return
      this.loading = true
      graph_client.request(DestroyPtv2PlannedTrail, { plannedTrail: { id: trail.id } })
        .then(() => this.searchPlannedTrails(true))
        .catch(err => { console.error('Error deleting planned trail:', err); this.loading = false })
    },
    triggerCopyModel (e, trail) {
      e.preventDefault()
      this.$nextTick(() => {
        const input = document.getElementById('trailShareInput')
        const modalEl = document.getElementById('copyModal')
        if (!input || !modalEl) return console.error('Share modal elements not found')
        input.value = trail.shareableUrl
        Modal.getOrCreateInstance(modalEl).show()
      })
    },
    copyToClipboard () {
      const input = document.getElementById('trailShareInput')
      if (!input) return
      input.select(); input.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(input.value).then(() => {
        const conf = document.getElementById('copyURLConfirmation')
        if (conf) { conf.style.display = 'inline'; setTimeout(() => { conf.style.display = 'none' }, 2000) }
      }).catch(err => console.error('Failed to copy text:', err))
    },

    /* ---------- NEW: GPX Export ---------- */
    async exportGpx (trail) {
      try {
        const { ptv2PlannedTrailById: planned } = await graph_client.request(GetPtv2PlannedTrail, { id: trail.id })

        // Build coordinate array from stored FeatureCollection
        const geojson = planned.geojsonFeatureCollection;
        const coords = getFeatureCollectionLineString(geojson)

        const gpx = geojsonToGpx(
          {
            type: 'Feature',
            properties: {},
            geometry: { type: 'LineString', coordinates: coords }
          },
          null, // planned trails don’t have timestamps
          {
            creator: 'Hiiker',
            metadata: { name: planned.title, time: planned.createdAt }
          }
        )

        const blob = new Blob([gpx], { type: 'application/gpx+xml' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${planned.title || 'planned-trail'}.gpx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (err) {
        console.error('Error exporting GPX:', err)
        alert('Something went wrong generating the GPX. Please try again.')
      }
    }
  }
}
</script>

<style scoped>
.dropdown-toggle::after { display: none; }
.see-more { margin-top: 20px; }
.see-more button { padding: 10px 20px; font-size: 16px; }
</style>
